/* 设置元素高度为占满 */

import {useRef} from "react";
import { useMount,useWindowSize } from 'react-use';


export default function useSetHeight (bottomHeight?: number) {
  
  const ref = useRef(null);
  
  const {height} = useWindowSize();
  
  
  useMount(() => {
    if (ref.current) {
      // @ts-ignore
      const rectObject = ref.current.getBoundingClientRect();
      const {top} = rectObject;
      let groupHeight = height - top;
      if (bottomHeight) groupHeight = groupHeight - bottomHeight;
      // @ts-ignore
      ref.current.style.height = groupHeight + 'px';
    }
  })
  
  return ref;
  
}
